import React from "react";
import { TrashCan } from "../../../constants/Icons";
import { IHabitatViewObj } from "../../../shared/apiServices/IApiInterfaces";

export const rowFormIds = {
    location: 'Location',
    type: 'Type',
    name: 'Name',
    number: 'Number',
    deleteBtn: 'DeleteBtn'
}

const HabitatRow = (props: {
    handleChange: (habitat: IHabitatViewObj) => void;
    deleteHabitat: (habitat: IHabitatViewObj) => void;
    habitat: IHabitatViewObj,
    locations: any[],
    types: string[],
    index: number,
    text: {
        locationDropdownLabel: string,
        boxTypeDropdownLabel: string,
        nameLabel: string,
        numberLabel: string
    }
}) => {
    const { habitat, locations, types, index } = props;
    const { locationDropdownLabel, boxTypeDropdownLabel, nameLabel, numberLabel } = props.text;
    const { name, number } = props.habitat;

    const uniqueId = habitat.uiId;
    const numberId = `number-${uniqueId}`
    const nameId = `name-${uniqueId}`

    const handleLocationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        props.handleChange({ ...habitat, locationId: e.currentTarget.value });
    }
    const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        props.handleChange({ ...habitat, type: e.currentTarget.value });
    }
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.handleChange({ ...habitat, name: e.target.value });
    }
    const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        const newTrimmedValue = newValue.replace(/\D/g, '') ?? '';
        props.handleChange({ ...habitat, number: newTrimmedValue });
    }

    return <div className='habitat-row row'>
        <form className='habitat-row-form row col l10'>
            <div className='habitat-row-select col l3'>
                <select onChange={handleLocationChange} className='browser-default' value={habitat.locationId === undefined ? "" : habitat.locationId} data-testid={`${rowFormIds.location}-${index}`}>
                    <option value='' disabled >{locationDropdownLabel}</option>
                    {locations.map((location: any, i: number) => {
                        const props: any = { value: JSON.stringify({ id: location.id, name: location.name }) };
                        return <option {...props} key={i + 1} value={location.id}>
                            {location.name}
                        </option>
                    })}
                </select>
            </div>
            <div className='habitat-row-select col l3'>
                <select onChange={handleTypeChange} className='browser-default' value={habitat.type === undefined ? "" : habitat.type} data-testid={`${rowFormIds.type}-${index}`}>
                    <option value='' disabled >{boxTypeDropdownLabel}</option>
                    {types.map((type: string, i: number) => {
                        const props: any = { value: type };
                        return <option {...props} key={i + 1} value={type}>
                            {type}
                        </option>
                    })}
                </select>
            </div>
            <div className='habitat-row-input input-field col l3'>
                <input onChange={handleNameChange} type='text' placeholder='' id={nameId} value={name || ''} data-testid={`${rowFormIds.name}-${index}`} />
                <label className='active' htmlFor={nameId}>{nameLabel}</label>
            </div>
            <div className='habitat-row-input input-field col l3'>
                <input onChange={handleNumberChange} type='text' placeholder='' id={numberId} value={number || ''} data-testid={`${rowFormIds.number}-${index}`} />
                <label className='active' htmlFor={numberId}>{numberLabel}</label>
            </div>
        </form>
        <div className='col l2 left-align'>
            {/* Don't delete commented code.  This is in reference to https://monsanto.aha.io/features/ITH-241.  Functionality is temporarily being disabled */}

            {/* <div onClick={() => props.deleteHabitat(habitat)} className='habitat-row-trashcan' data-testid={`${rowFormIds.deleteBtn}-${index}`}>
                {TrashCan}
            </div> */}
        </div>
    </div>
}

export default HabitatRow;
